/**
 * Objections are org-configurable, but this one id is referenced by
 * non-configurable UI logic (building/chip styling, the follow-up date
 * field) because it's a "not-now" signal rather than a decline — see
 * canvassing-crm-high-level-design.md §6.1.
 */
export const COME_BACK_LATER_OBJECTION_ID = 'obj-come-back-later';

/** Org-configurable objection list. Seeded rows have `is_system = 1`. */
export interface Objection {
  id: string;
  label: string;
  sort_order: number;
  is_active: number;
  is_system: number;
  created_by: string;
  created_at: number;
  updated_by: string;
  updated_at: number;
  deleted_at: number | null;
}
